<template>
  <div class="drawer">
    <slot></slot>
    <div v-if="$slots.buttons" :class="['links', {'vertical': vertical}]">
      <slot name="buttons">
      </slot>
    </div>
  </div>
</template>
<script lang="ts" setup>

withDefaults(defineProps<{
  showDetails?:boolean,
  vertical?:boolean,
}>(), {
  showDetails: true,
  vertical: false,
});

</script>
<style lang="scss">
.drawer {
  padding: 16px 16px;
  background-color: var(--pidz-blue);
  width: 100%;
  position: sticky;
  bottom: 0;
  border-radius: 14px 14px 0 0;
  color: var(--pidz-white);
  display: flex;
  flex-direction: column;
  gap: 12px;

  .links {
    display: grid;
    grid-auto-columns: auto auto;
    grid-auto-columns: 1fr 1fr;
    grid-auto-flow: column;
    column-gap: 16px;

    &.vertical {
      grid-auto-flow: row;
      row-gap: 12px;
    }

    a, button {
      border: 0;
      font-family: inherit;
      color: var(--pidz-blue);
      display: block;
      text-decoration: none;
      width: 100%;
      padding: 12px;
      font-size: 16px;
      background-color: var(--pidz-white);
      text-align: center;
      &.error {
        background: var(--pidz-red);
        color: var(--pidz-white);
      }

      &:disabled {
        opacity: 0.75;
        pointer-events: none !important;
        touch-action: none;
      }

      &:visited {
        color: var(--pidz-blue);
      }
    }
  }
}
</style>
